// ZoneAStatusSkeleton — placeholder card for Zone A's loading state.
//
// Extracted 2026-05-26 from TodayScreen.tsx — the exact same block was
// inlined at two different points in the rendering branches (the
// planLoading branch and the progressLoading branch). DRYing it into
// one component eliminates the drift risk and shrinks TodayScreen by
// ~20 LoC.
//
// The shape mirrors the loaded Zone A — a 96×96 round avatar slot, a
// title + subtitle pair, and a 72×72 trailing badge — so the layout
// settles into its final position without a reflow when the data
// arrives.

import { Card } from '../ui/Card';
import { Skeleton } from '../ui/Skeleton';

export function ZoneAStatusSkeleton() {
  return (
    <Card>
      <div className="row" style={{ alignItems: 'center', gap: 'var(--space-5)' }}>
        <Skeleton width={96} height={96} radius="50%" />
        <div style={{ flex: 1 }}>
          <Skeleton height={32} width="40%" />
          <Skeleton height={14} width="60%" style={{ marginBlockStart: 'var(--space-2)' }} />
        </div>
        <Skeleton width={72} height={72} radius="50%" />
      </div>
    </Card>
  );
}
